import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PDFViewer } from '@react-pdf/renderer';
import MintePdf from '@components/MintePdf';
import { Result } from 'antd';
import PdfViewActions, { PdfViewSelectors } from '@redux/PdfViewRedux';

function PdfView(props) {
  const { text, resetPdfData } = props;

  useEffect(() => {
    return () => {
      resetPdfData();
    };
  }, [text]);

  if (!text) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
      />
    );
  }

  return (
    <PDFViewer>
      <MintePdf text={text} />
    </PDFViewer>
  );
}

PdfView.propTypes = {
  resetPdfData: PropTypes.func,
  text: PropTypes.string
};

const mapStateToProps = state => ({
  text: PdfViewSelectors.selectPdfText(state)
});

const mapDispatchToProps = dispatch => ({
  resetPdfData: () => {
    dispatch(PdfViewActions.setPdfData(''));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdfView);
